import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { mainBlueColor, workingBudgetData, btnColor } from '../../GlobalState';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';

type TProps = {
  isDetailShow: boolean;
  setIsDetailShow: any;
};

/**
 * テーブルヘッダー
 * @constructor
 */
export const CheckDisplay: React.FC<TProps> = (props: TProps) => {
  const { setIsDetailShow } = props;
  const [isChecked, setIsChecked] = useState(false);
  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });
  const [buttonColor] = useRecoilState(btnColor);

  const handleChange = (val: any) => {
    if (isChecked) {
      setIsChecked(false);
      setIsDetailShow(false);
    } else {
      setIsChecked(true);
      setIsDetailShow(true);
    }
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox
        checked={isChecked}
        className={classes.toggleButtonGroup}
        onClick={handleChange}
        style={{
          color: buttonColor
        }}
      />
      <div style={{ marginLeft: -12, marginBottom: 3 }}>
        項目の詳細を表示する
      </div>
      <CustomTooltip title={tooltipContents.displayDetails} placement='right'>
        <HelpIcon color='action' style={{ marginLeft: 8 }} />
      </CustomTooltip>
    </div>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    toggleButtonGroup: {
      margin: 10
    }
  })
);
